import datalayer from '../helpers/datalayer'

class AButton {
  constructor (el) {
    this.link = el

    this.init()
  }

  init () {
    // there will only ever be one link in each atom
    this.link.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      if (this.link.dataset.productHandle) {
        // this should trigger for buttons that have a data-product-handle attribute
        // it is a click event, but not an add to cart event
        return new Promise((resolve, reject) => {
          datalayer.getProductByHandle(this.link.dataset.productHandle)
            .then((response) => {
              // console.log('Button product click data response:', response)
              return response
            })
            .then((data) => {
              // console.log('Button product click data resolve:', data)

              datalayer.pushProductClickEvent(data, this.link.dataset.productList, this.link.dataset.productPosition, this.link.href)

              resolve()
            })
            .catch((err) => {
              console.error('Button product click error:', err)

              reject(err)
            })
        })
      }
    })
  }
}

window.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-a-button]:not([ref="noProductClick"')
    .forEach(el => new AButton(el))
})
